<h1 class="main sticky-top">
    <div class="row">
        <div class="col-sm-4">Template Types</div>
    </div>
</h1>
<div class="content">
    <div *ngFor="let templateType of edlTemplateTypes; trackBy: trackByFn" class="mb-4">
        <edl-template-type-entry 
            [edlTemplateType]="templateType"
            [busy]="busy"
            (saveEvent)="onSave($event)"
            (deleteEvent)="onDelete($event)">
        </edl-template-type-entry>
    </div>
    <button class="btn btn-primary" (click)="onCreate()" [disabled]="busy">
        <i class="fas fa-plus"></i> Add Template Type
    </button>
</div>
